import { createAction } from 'redux-act';

export const fetchEventList = createAction('fetch event-list');
export const failFetchEventList = createAction('fail fetch event-list');
export const successFetchEventList = createAction('success fetch event-list');



// WEBPACK FOOTER //
// ./src/actions/event.js